/**
 * @generated SignedSource<<f6f5987ed4ebd2a380664e9416a00143>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryMilestoneIndexPageContentInternal$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryMilestonesInternal">;
  readonly " $fragmentType": "RepositoryMilestoneIndexPageContentInternal";
};
export type RepositoryMilestoneIndexPageContentInternal$key = {
  readonly " $data"?: RepositoryMilestoneIndexPageContentInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryMilestoneIndexPageContentInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "state"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryMilestoneIndexPageContentInternal",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "state",
          "variableName": "state"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RepositoryMilestonesInternal"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "eb52829b796ead980a5fa6ca99ae1835";

export default node;
